import { PciChartProps } from "reports/types";
import WeeklyMultiShiftBarChart from "../../../../../components/Reports/GenericCharts/WeeklyMultiShiftBarChart";

import { planned, darkBlue } from "../../../../../constants/colors";

import PciCustomLegend from "reports/pages/customers/pci/Utils/PciCustomLegend";

const bars = [
  {
    key: "mech",
    name: "Setup",
    fill: planned,
    stackId: 1,
  },
  {
    key: "clean",
    name: "Clean",
    fill: darkBlue,
    stackId: 1,
  },
];
const plannedMechTags = ["planned-Production Set", "planned-First Piece"];
const plannedCleanTags = ["planned-Accountability"];
/**
 * generate and create bar chart based on given data
 */
export default function PlannedDowntimePerShift({
  data,
  width,
  height,
}: PciChartProps) {
  // starts with format planned-pc mech set, planned-lc mech set, we want to end up fusing all planned-mech and planned-clean groupings togethe
  const processedData = data?.map(datum => {
    const groupedTags = Object.entries(datum).reduce(
      (acc, [key, value]) => {
        return key.includes("planned") &&
          (key.includes("Mech") || plannedMechTags.includes(key))
          ? { ...acc, mech: acc.mech + Number(value) }
          : key.includes("planned") &&
              (key.includes("Clean") || plannedCleanTags.includes(key))
            ? { ...acc, clean: acc.clean + Number(value) }
            : acc;
      },
      { mech: 0, clean: 0 }
    );
    return { ...datum, ...groupedTags };
  });

  const title = "Changeover Trend per Shift";
  return (
    <WeeklyMultiShiftBarChart
      title={title}
      data={processedData}
      xLabel={""} // no label required
      yLabel={"Hours"}
      bars={bars}
      width={width}
      height={height}
      useGrid={true}
      legend={PciCustomLegend(width, title)}
    />
  );
}
